import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getToken } from '../../utils/token';

export const orgReportApi = createApi({
  reducerPath: 'orgReportApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL+"/api",
    prepareHeaders: (headers) => {
      const token = getToken();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    orgReportApi: builder.mutation({
      query: (credentials) => ({
        url: `/GetOrgReport`,
        method: 'POST',
        body: credentials,
      }),
    }),
  }),
});

export const { useOrgReportApiMutation } = orgReportApi;
